"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$grey, _item, _theme$palette2, _theme$palette2$prima, _theme$palette3, _theme$palette3$prima;

  return {
    item: (_item = {
      border: "1px solid ".concat((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$grey = _theme$palette.grey) === null || _theme$palette$grey === void 0 ? void 0 : _theme$palette$grey[100]),
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(2),
      position: "relative",
      transition: theme.transitions.create(["background", "border"], {
        duration: theme.transitions.duration.shorter
      })
    }, _defineProperty(_item, theme.breakpoints.up("sm"), {
      padding: theme.spacing(3)
    }), _defineProperty(_item, theme.breakpoints.up("md"), {
      padding: theme.spacing(5)
    }), _item),
    itemNew: {
      alignItems: "center",
      color: theme.palette.primary.main,
      cursor: "pointer",
      fontWeight: 700,
      gap: theme.spacing(1),
      justifyContent: "center",
      userSelect: "none",
      "&:hover": {
        borderColor: theme.palette.primary.main
      }
    },
    itemSelectable: {
      cursor: "pointer",
      userSelect: "none",
      "&:hover": {
        background: (0, _colorManipulator.alpha)((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$prima = _theme$palette2.primary) === null || _theme$palette2$prima === void 0 ? void 0 : _theme$palette2$prima.main, 0.05),
        borderColor: theme.palette.primary.main
      }
    },
    itemSelected: {
      background: (0, _colorManipulator.alpha)((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$prima = _theme$palette3.primary) === null || _theme$palette3$prima === void 0 ? void 0 : _theme$palette3$prima.main, 0.05),
      borderColor: theme.palette.primary.main
    },
    name: {
      fontSize: "1.5rem",
      marginBottom: theme.spacing(3)
    },
    company: {},
    address: {},
    defaults: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
      marginTop: "auto",
      paddingTop: theme.spacing(8)
    },
    defaultShipping: {
      alignItems: "center",
      color: theme.palette.grey[600],
      display: "flex",
      gap: theme.spacing(2)
    },
    defaultBilling: {
      alignItems: "center",
      color: theme.palette.grey[600],
      display: "flex",
      gap: theme.spacing(2)
    },
    buttons: {
      display: "flex",
      gap: theme.spacing(1),
      marginTop: theme.spacing(3)
    },
    select: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1)
    }
  };
});
var _default = styles;
exports.default = _default;